import type { DetectionBox } from "@aimosaic/core";

export interface BoxesState {
  past: DetectionBox[][];
  present: DetectionBox[];
  future: DetectionBox[][];
}

export type BoxesAction =
  | { type: "set"; boxes: DetectionBox[] }
  | { type: "add"; box: DetectionBox }
  | { type: "update"; id: string; box: Partial<DetectionBox> }
  | { type: "remove"; id: string }
  | { type: "toggle-action"; id: string }
  | { type: "undo" }
  | { type: "redo" }
  | { type: "reset" };

export const initialBoxesState: BoxesState = {
  past: [],
  present: [],
  future: []
};

export function boxesReducer(state: BoxesState, action: BoxesAction): BoxesState {
  switch (action.type) {
    case "set":
      return push(state, action.boxes);
    case "add":
      return push(state, [...state.present, action.box]);
    case "update":
      return push(
        state,
        state.present.map((box) => (box.id === action.id ? { ...box, ...action.box } : box))
      );
    case "remove":
      return push(
        state,
        state.present.filter((box) => box.id !== action.id)
      );
    case "toggle-action":
      return push(
        state,
        state.present.map((box) =>
          box.id === action.id ? { ...box, action: box.action === "mask" ? "ignore" : "mask" } : box
        )
      );
    case "undo": {
      const previous = state.past.at(-1);
      if (!previous) return state;
      return {
        past: state.past.slice(0, -1),
        present: previous,
        future: [state.present, ...state.future]
      };
    }
    case "redo": {
      const next = state.future[0];
      if (!next) return state;
      return {
        past: [...state.past, state.present],
        present: next,
        future: state.future.slice(1)
      };
    }
    case "reset":
      return initialBoxesState;
  }
}

function push(state: BoxesState, next: DetectionBox[]): BoxesState {
  return {
    past: [...state.past, state.present],
    present: next,
    future: []
  };
}
